var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMsicSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1646211106806,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 6552,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.1 576.1h476c42.8 0 64.2 51.8 34 82l-238 238a47.8 47.8 0 0 1-67.6 0.2l-0.2-0.2-238.2-238c-30.1-30.1-8.8-82 34-82z",
    opacity: 0.2,
    fill: "#ABC4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.1 366.1l238.2-238A47.8 47.8 0 0 1 546 128a1.88 1.88 0 0 1 0.2 0.2l238 238c30.2 30.2 8.8 82-34 82h-476c-42.9-0.1-64.2-51.9-34.1-82.1z",
    opacity: 0.2,
    fill: "#ABC4FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsicSort);
export default __webpack_public_path__ + "static/media/msic-sort.ebabf818f3d67fb1afff0fdca08bf992.svg";
export { ForwardRef as ReactComponent };